import Template from "./Template.es6";
export default class Layout {
    constructor(Component) { this.Component = Component }
    get Template()      { return this._template || (this._template = new Template(this.Component)) }
    async setPrice(content)  {
        if (content) {
            this.price.innerHTML = content;
            let cartButton = this.price.querySelector('.js-box-button-cart');
            if (cartButton) {
                this.Component.quickBuy ?
                    cartButton.dataset.offerId = await this.Component.values.offer :
                    cartButton.dataset.productId = this.Component.values.id ;
            }
        }
    }
    get price()         { return this.Component.container.querySelector('.offer-container') }
    set title(content)  { if (content) this.title.innerHTML = content }
    get title()         { return this.Component.container.querySelector('.title') }
    set buttons(content){ if (content) this.buttons.innerHTML = content }
    get buttons()       { return this.Component.container.querySelector('.box-buttons') }
    set hints(content)  { if (content) this.hints.innerHTML = content }
    get hints()         { return this.Component.container.querySelector('.hints-container') }
    set image(content)  { if (content) this.image.innerHTML += content }
    get image()         { return this.Component.container.querySelector('.image-container') }
    set badge(content)  { if (content) this.badge.outerHTML = content }
    get badge()         { return this.Component.container.querySelector('.badge') }
    set reference(content)
    { if (content) this.reference.outerHTML = content }
    get reference()
    { return this.Component.container.querySelector('.box-reference') }

    getButton(type) {
        // alter button in case required
        switch (type) {
            case 'cart':
                return this.getCartButton(this.Component.values.type);
            default:
                const values = this.Component.values;
                if (!values.target) values.target = '_self'; // Race condition: Fallback, sometimes is empty
                return type === 'null' ? null : App.Template.parse('box-button-' + type, values);
        }
    }

    getCartButton(type) {
        switch (type) {
            case 0:
                if (!this.Component.values.availability) {
                    return App.Template.parse('box-button-soldout', this.Component.values);
                } else {
                    return this.Component.Buttons.hasInformationButton() ?
                    '' : App.Template.parse('box-button-mix', this.Component.values);
                }
            case 40:
                return '';
            default:
                return this.getDefaultButton();
        }
    }

    getDefaultButton() {
        if (this.Component.values.hasAvailableOffers) {
            if (this.Component.quickBuy) {
                return App.Template.parse('box-button-cart-offer', this.Component.values.Offer);
            } else {
                return App.Template.parse('box-button-cart', this.Component.values);
            }
        } else {
            return App.Template.parse('box-button-soldout', this.Component.values);
        }
    }
}
